(ns frontend.view.settings2.connected-plugins.sub
  "Subscriptions for Connected Plugins settings"
  (:require
   [re-frame.core :as rf]
   [ui.state.session.sub :as session-sub]))

;; Root path for connected plugins state in the app-db
(def root-path [::state])

;; Subscriptions

(rf/reg-sub
 ::state
 (fn [db]
   (get-in db root-path)))

(rf/reg-sub
 ::loading-state
 :<- [::state]
 :loading-state)

(rf/reg-sub
 ::connections
 :<- [::state]
 :connections)

(rf/reg-sub
 ::error
 :<- [::state]
 :error)

(rf/reg-sub
 ::generating?
 :<- [::state]
 (fn [state]
   (:generating? state false)))

(rf/reg-sub
 ::revoking?
 :<- [::state]
 (fn [state]
   (:revoking? state false)))

(rf/reg-sub
 ::read-only?
 :<- [::state]
 (fn [state]
   (:read-only? state false)))

(rf/reg-sub
 ::pairing-code
 :<- [::state]
 (fn [state [_ plugin-type]]
   (get-in state [:plugin-codes plugin-type :pairing-code])))

(rf/reg-sub
 ::pairing-code-expires
 :<- [::state]
 (fn [state [_ plugin-type]]
   (get-in state [:plugin-codes plugin-type :pairing-code-expires])))

(rf/reg-sub
 ::pairing-error
 :<- [::state]
 (fn [state [_ plugin-type]]
   (get-in state [:plugin-codes plugin-type :pairing-error])))

(rf/reg-sub
 ::revoke-error
 :<- [::state]
 :revoke-error)

(rf/reg-sub
 ::connection-name
 :<- [::state]
 (fn [state]
   (:connection-name state "")))

(rf/reg-sub
 ::connection-name-loaded?
 :<- [::state]
 (fn [state]
   (:connection-name-loaded? state false)))

(rf/reg-sub
 ::plugin-type
 :<- [::state]
 (fn [state]
   (:plugin-type state :plugin.type/outlook)))

(rf/reg-sub
 ::polling?
 :<- [::state]
 (fn [state]
   (:polling? state false)))

(rf/reg-sub
 ::connection-established?
 :<- [::state]
 (fn [state]
   (:connection-established? state false)))

(rf/reg-sub
 ::connection-lifetime
 :<- [::state]
 :connection-lifetime)

(rf/reg-sub
 ::tenant-max-lifetime
 :<- [::state]
 :tenant-max-lifetime)

(rf/reg-sub
 ::tenant-mcp-max-lifetime
 :<- [::state]
 :tenant-mcp-max-lifetime)

(rf/reg-sub
 ::mcp-url
 :<- [::state]
 :mcp-url)

(rf/reg-sub
 ::connections-for-plugin-type
 :<- [::connections]
 (fn [connections [_ plugin-type]]
   (filterv #(= (:token/plugin-type %) plugin-type) connections)))

(rf/reg-sub
 ::hidden-emails
 :<- [::session-sub/account]
 (fn [account]
   (let [prefs (:account/preferences account)]
     (vec (sort (get prefs :outlook-addin-hidden-emails #{}))))))
